"use client";

import { AppointmentSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedAppointmentSection from "../Components/GeneratedAppointmentSection";

const Appointment: FC<AppointmentSectionProps> = (props) => {
  return <GeneratedAppointmentSection {...props} />;
};

export default Appointment;
